import { render, staticRenderFns } from "./PageOverviewItems.vue?vue&type=template&id=55c76116&"
import script from "./PageOverviewItems.vue?vue&type=script&lang=ts&"
export * from "./PageOverviewItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports